import React from 'react';
import styles from './quote.module.css';

export interface QuoteData {
  text: string;
  author: string;
  citation?: string;
}

interface QuoteProps {
  quote: QuoteData;
  fontSize?: string;
  className?: string;
}

// Helper to process text: Smart quotes + Allow HTML/Markdown-ish bold/italic
export const formatText = (text: string | undefined) => {
  if (!text) return { __html: '' };

  let processed = text;

  // 1. Simple Markdown parsing
  // Bold: **text** -> <strong>text</strong>
  processed = processed.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // Italic: *text* -> <em>text</em>
  processed = processed.replace(/\*(.*?)\*/g, '<em>$1</em>');

  // 2. Smart Quotes (replace ' with right single quote like &rsquo;)
  processed = processed.replace(/'/g, '&rsquo;');

  // Return for dangerouslySetInnerHTML
  return { __html: processed };
};

export default function Quote({ quote, fontSize, className = '' }: QuoteProps) {
  const customBlockquoteStyle = fontSize ? { fontSize } : undefined;

  return (
    <div className={`${styles.quoteContainer} ${className}`.trim()}>
      <div
        className={styles.blockquote}
        style={customBlockquoteStyle}
        dangerouslySetInnerHTML={formatText(quote.text)}
      />
      <div className={styles.authorBlock}>
        <cite
          className={styles.cite}
          dangerouslySetInnerHTML={formatText(quote.author)}
        />
        {quote.citation && (
          <span
            className={styles.citation}
            dangerouslySetInnerHTML={formatText(quote.citation)}
          />
        )}
      </div>
    </div>
  );
}
